import React from "react";
import "./Loader.scss";
export function Loader() {
    return <div className="lds-dual-ring"></div>;
}
